var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Charon from "./charon";
import { MVT } from "ol/format";
import TileLayer from "ol/layer/Tile";
import VectorTileLayer from "ol/layer/VectorTile";
import VectorTileSource from "ol/source/VectorTile";
import XYZ from "ol/source/XYZ";
import stylefunction from "ol-mapbox-style/dist/stylefunction";
export class OSMLayer {
    getLayer() {
        const layer = new TileLayer({
            source: new XYZ({
                url: new Charon().tileURL,
                attributions: ['Powered by <a href="https://www.geoapify.com/" target="_blank">Geoapify</a>',
                    '<a href="http://openmaptiles.org/" target="_blank">© OpenMapTiles</a>',
                    '© <a href="http://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>',
                ],
            }),
        });
        return layer;
    }
}
export class MapboxLayer {
    getLayer() {
        const mapboxLayer = new VectorTileLayer({
            declutter: true,
            source: new VectorTileSource({
                format: new MVT(),
                url: new Charon().tileURL,
                attributions: '© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> <strong><a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a></strong>',
            }),
        });
        this.applyMapboxStyle(mapboxLayer);
        return mapboxLayer;
    }
    applyMapboxStyle(mapboxLayer) {
        return __awaiter(this, void 0, void 0, function* () {
            const glStyle = yield new Charon().getStyle();
            const styleLayers = glStyle.layers
                .filter((layer) => {
                return layer.hasOwnProperty("source");
            })
                .map((layer) => layer.id);
            stylefunction(mapboxLayer, glStyle, styleLayers);
        });
    }
}
